import *as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import './Subscription.css'
import { IoCopyOutline } from "react-icons/io5"
import IconButton from '@mui/material/IconButton';
import { BsFillCheckCircleFill } from "react-icons/bs";
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import Divider from '@mui/material/Divider';
import Expand from './expandcard'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PropaneRounded } from '@mui/icons-material';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import Tooltip from '@mui/material/Tooltip';
export default function Subscription(props) {
  return (
    <Grid container spacing={2}>
      <Grid item md={1}/>
      <Grid item md={9}>
        <div className='header'>
          <div className='header'>
            <Paper elevation={0} id={props.status===1? 'paperdesign':'paperdesign2'} sx={{ p: 2, margin: 'auto', maxWidth: '150%', flexGrow: 1 ,}}>
              <Grid container spacing={1} id="paper">
                <Grid item>
                  <Typography variant="subtitle1" id='subtitle' component="div">{props.title}</Typography>
                </Grid>
                <Grid item xs={2} sm container>
                  <Grid item xs container direction="column" spacing={1}>
                </Grid>          
                <Grid item>
                  <div id='v1'/>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle1" component="div" id="Typography" >Support Status<br/> </Typography>
                 <a style={{ color: props.color,fontSize:'20px' }}>{props.status}</a><br/>
                  <p>{props.serverid}</p>
                  <p>{props.date}</p>
                  <p>{props.time}</p>
                </Grid>
              </Grid>
              <Grid container spacing={1} id="paper">
                <Grid item>
                  <Divider/>
                  <p id="key">License key: <a id="number">{props.Key}</a>  
                  <CopyToClipboard >
                    <IconButton>
                      <ContentCopyOutlinedIcon onClick={props.copy}>Copy</ContentCopyOutlinedIcon>
                    </IconButton>
                  </CopyToClipboard></p> 
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </div>
        <Accordion sx={{ p: 2, margin: 'auto', maxWidth: '180%', flexGrow: 1 ,}}>
          <AccordionSummary
            expandIcon={<PlayCircleFilledWhiteOutlinedIcon />}
            aria-controls="panelbh-content"
            id="panelbh-header">
          </AccordionSummary>
          <AccordionDetails>
            {props.customer}
          </AccordionDetails>
        </Accordion>
      </div>
    </Grid>
    <Grid item md={2}/>
   </Grid>

  );
}

